<template>
    <div class="list-content">
        <div class="question-item" v-for="item in 5">
            <div class="question-content">
                <div class="question-faceimg">
                    <img src="../../assets/img/touxiang.png" alt=""  width="55">
                </div>
                <div>
                    <p><span>xiaohutu211</span> <span class="ml10">2019-01-24</span></p>
                    <p class="corblue">主题主222题主题主题</p>
                    <p>i think this is a good study video.</p>
                </div>
            </div>
            <!--<div class="question-switch ">-->
            <!--<el-tooltip :content="123" placement="top" class="mr10 fl mt12">-->
            <!--<el-switch-->
            <!--:width="50"-->
            <!--v-model="v"-->
            <!--active-color="#13ce66"-->
            <!--inactive-color="#ff4949"-->
            <!--active-value="2"-->
            <!--inactive-value="1">-->
            <!--</el-switch>-->
            <!--</el-tooltip>-->
            <!--</div>-->
            <div class="question-footer">
                <i class="el-icon-delete" style="font-size: 16px;padding: 5px;" ></i>
                <i class="el-icon-chat-dot-round" style="font-size: 16px;padding: 5px;" @click="replayQuestion"><span style="font-size: 12px;padding: 5px;">(3)</span></i>
            </div>
        </div>
    </div>
</template>

<script>
  import https from '@/https.js'
  export default {
    name: "",
    data() {
      return {
        tag:null,
        total:100,
        dialogVisible: false,
        editForm:{
          title:null,
          content:null
        },
        formData: {
          textarea: "",
        },
        searchForm:{
          searchValue:null,
          searchSort:null,
          pageSize:10,
          page:1
        },
        centerDialogVisible: false,
        currentPage4: 4
      }
    },
    methods: {
      replayQuestion(){
        window.location.href = 'step6-replay.html?questionId=111';
      },

      save() {
        let params = {
          courseId: this.courseId,
          examineContext: this.formData.textarea
        };
        https.fetchPost('/courseCheck/checkCommit',params ).then((data) => {
          let code = data.data.code;
          if(code == 200) {
            this.$message({
              type: 'success',
              message: '审核成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '审核失败'+msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
            }
        )
      },
    },
    created(){
    },

  }
</script>

<style scoped>

</style>